var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentHub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.142,
    height: 79.156,
    viewBox: "0 0 79.142 79.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PaymentHUB",
    transform: "translate(0.128 0.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M6.679,48.795a2.561,2.561,0,0,0,2.847,2.234l3.01-.364-3.188,14a2.561,2.561,0,0,0,1.929,3.066L69.846,81.075a2.585,2.585,0,0,0,.574.065,2.562,2.562,0,0,0,2.493-1.993l8.157-35.8a2.559,2.559,0,0,0-1.929-3.066l-8.046-1.833L66.991,4.5a2.609,2.609,0,0,0-2.858-2.235L4.5,9.481a2.557,2.557,0,0,0-2.223,2.858c1.6,13.248-.93-7.642,4.407,36.456ZM66.8,17.983,5.668,25.38l-.8-6.625L66,11.359ZM79.308,42.94l-8.157,35.8a.76.76,0,0,1-.9.568L11.678,65.967a.755.755,0,0,1-.568-.9C14.2,51.5,16.3,42.282,19.266,29.26a.754.754,0,0,1,.9-.568L78.739,42.037A.752.752,0,0,1,79.308,42.94ZM20.573,26.929a2.561,2.561,0,0,0-3.067,1.929L12.963,48.8l-3.652.441a.757.757,0,0,1-.838-.656L5.885,27.174l61.134-7.4,2.205,18.239ZM4.721,11.273,64.348,4.059a.767.767,0,0,1,.853.668l.585,4.837L4.65,16.962l-.587-4.848A.754.754,0,0,1,4.721,11.273Z",
    transform: "translate(-2.251 -2.249)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M22.957,47.869l-4.793-1.092a3.176,3.176,0,0,0-1.411,6.193l4.793,1.091a3.175,3.175,0,1,0,1.412-6.192Zm.629,3.4a1.368,1.368,0,0,1-1.638,1.03l-4.795-1.092a1.369,1.369,0,0,1,.608-2.669l4.793,1.092a1.37,1.37,0,0,1,1.031,1.639Z",
    transform: "translate(0.206 6.836)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M29.551,49.371a3.176,3.176,0,0,0-1.412,6.193l4.793,1.092a3.176,3.176,0,0,0,1.412-6.193Zm5.423,4.492a1.367,1.367,0,0,1-1.638,1.03L28.543,53.8a1.369,1.369,0,0,1,.608-2.669l4.793,1.092A1.368,1.368,0,0,1,34.975,53.864Z",
    transform: "translate(2.536 7.366)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M39.529,58.16l4.795,1.092a3.176,3.176,0,0,0,1.411-6.193l-4.793-1.092a3.176,3.176,0,0,0-1.413,6.193Zm-.629-3.4a1.367,1.367,0,0,1,1.638-1.03l4.793,1.092a1.369,1.369,0,0,1-.608,2.669L39.93,56.4A1.368,1.368,0,0,1,38.9,54.758Z",
    transform: "translate(4.862 7.896)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M57.124,55.654l-4.793-1.092a3.176,3.176,0,0,0-1.412,6.193l4.793,1.092a3.176,3.176,0,0,0,1.411-6.193Zm.629,3.4a1.365,1.365,0,0,1-1.638,1.03L51.32,58.991a1.369,1.369,0,0,1,.608-2.669l4.793,1.092A1.369,1.369,0,0,1,57.753,59.054Z",
    transform: "translate(7.188 8.427)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M16.942,38.151l-.733,3.221a1.622,1.622,0,0,0,1.218,1.939L35.18,47.355a1.639,1.639,0,0,0,.365.042,1.619,1.619,0,0,0,1.574-1.26l.733-3.222a1.619,1.619,0,0,0-1.219-1.938L18.88,36.932a1.62,1.62,0,0,0-1.938,1.219Zm1.72.585L36.05,42.7l-.65,2.854L18.012,41.592Z",
    transform: "translate(0.592 4.831)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M45.922,49.758l15.014,3.42a1.662,1.662,0,0,0,1.99-1.253l2.664-11.691a1.664,1.664,0,0,0-1.253-1.99l-15.011-3.42a1.662,1.662,0,0,0-1.992,1.251L44.669,47.768A1.666,1.666,0,0,0,45.922,49.758Zm5.06-5.5L47.5,43.469l.532-2.335,3.479.792Zm-3.88.97,3.479.793-.637,2.8-3.479-.792Zm15.134,1.595-3.479-.792.531-2.335,3.481.794ZM61.2,51.385l-3.478-.792.637-2.8,3.479.792Zm1.973-8.656-4.361-.994a.9.9,0,0,0-1.081.68l-1.77,7.776-4.25-.968c.055-.242,2.6-11.414,2.6-11.41L63.8,39.976Zm-14.1-6.111,3.478.792-.627,2.753-3.478-.792Z",
    transform: "translate(6.41 4.4)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHub);
export default __webpack_public_path__ + "static/media/PaymentHub.cd8eb28c8cde60f614880585d1535efe.svg";
export { ForwardRef as ReactComponent };